<template>
  <div>
    <Head title="Packed Orders" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" :href="`/orders/delivery-runs/invoicing-queue`">Delivery Runs</Link>
      <span class="text-orange-400 font-medium">/</span>{{ user.name }}/Orders
    </h1>
    <div class="flex items-center justify-between mb-6">
      <!--<search-single-dropdown v-model="search.status" :items="statuses" class="mr-0 w-full max-w-md mr-3" @reset="reset"/>-->
    </div>
    <hr />
    <ul
      id="tabs-tabFill"
      class="nav nav-tabs flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 mb-4"
      role="tablist"
    >
      <li class="nav-item flex-auto text-center" role="presentation">
        <a
          id="tabs-home-tabFill"
          href="#tabs-homeFill"
          class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
          active" 
          data-bs-toggle="pill" 
          data-bs-target="#tabs-homeFill" 
          role="tab"
          aria-controls="tabs-homeFill"
          aria-selected="true"
        >
          Queue
        </a>
      </li>
      <li
        class="nav-item flex-auto text-center"
        role="presentation"
      >
        <a 
          id="tabs-profile-tabFill"
          href="#tabs-profileFill"
          class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent"
          data-bs-toggle="pill"
          data-bs-target="#tabs-profileFill"
          role="tab"
          aria-controls="tabs-profileFill"
          aria-selected="false"
        >
          Processed
        </a>
      </li>
    </ul>
    <div id="tabs-tabContentFill" class="tab-content">
      <div id="tabs-homeFill" class="tab-pane fade show active" role="tabpanel" aria-labelledby="tabs-home-tabFill">
        <div class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">Date</th>
              <th class="pb-3 pt-3 px-3">Order Number</th>
              <th class="pb-3 pt-3 px-3 text-center">Quantity</th>
              <th class="pb-3 pt-3 px-3">Status</th>
              <th class="pb-3 pt-3 px-3 text-end"></th>
            </tr>
            <tr v-for="list in pending" :key="list.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${user.username}/orders/${list.order_id}/skus`" title="">
                  {{ list.date }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${user.username}/orders/${list.order_id}/skus`" title="">
                  {{ list.order_no }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center justify-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${user.username}/orders/${list.order_id}/skus`" title="">
                  {{ list.quantity }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex tems-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${user.username}/orders/${list.order_id}/skus`" title="">
                  {{ list.status }}
                </Link>
              </td>
              <td class="w-px border-t">
                <a :href="`/orders/delivery-runs/invoicing-queue/users/${user.username}/orders/${list.order_id}/skus`" class="flex items-center justify-end pr-3">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                </a>
              </td>
            </tr>
            <tr v-if="pending.length === 0">
              <td class="px-3 py-3 border-t" colspan="5">No data found</td>
            </tr>
          </table>
        </div>
        <!-- <pagination class="mt-6" :links="orders.links" /> -->
      </div>
      <div id="tabs-profileFill" class="tab-pane fade" role="tabpanel" aria-labelledby="tabs-profile-tabFill">
        <div class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">Date</th>
              <th class="pb-3 pt-3 px-3">Order Number</th>
              <th class="pb-3 pt-3 px-3 text-center">Quantity</th>
              <th class="pb-3 pt-3 px-3">Status</th>
              <th class="pb-3 pt-3 px-3 text-end" />
            </tr>
            <tr v-for="list in processed" :key="list.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${user.username}/orders/${list.order_id}/skus`" title="">
                  {{ list.date }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${user.username}/orders/${list.order_id}/skus`" title="">
                  {{ list.order_no }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center justify-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${user.username}/orders/${list.order_id}/skus`" title="">
                  {{ list.quantity }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex tems-center px-3 py-3 focus:text-orange-500" :href="`/orders/delivery-runs/invoicing-queue/users/${user.username}/orders/${list.order_id}/skus`" title="">
                  {{ list.status }}
                </Link>
              </td>
              <td class="w-px border-t">
                <a :href="`/orders/delivery-runs/invoicing-queue/users/${user.username}/orders/${list.order_id}/skus`" class="flex items-center justify-end pr-3">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                </a>
              </td>
            </tr>
            <tr v-if="processed.length === 0">
              <td class="px-3 py-3 border-t" colspan="5">No data found</td>
            </tr>
          </table>
        </div>
        <!-- <pagination class="mt-6" :links="orders.links" /> -->
      </div>
    </div>
  </div>
</template>
      
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchSingleDropdown from '@/Shared/SearchSingleDropdown'
import Pagination from '@/Shared/Pagination'
      
export default {
  components: {
    Head,
    Link,
    SearchSingleDropdown,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    user: Object,
    orders: Object,
    statuses: Object,
    delivery_run: Object,
  },
  data() {
    return {
      search: {
        status: this.filters.status ? this.filters.status : 'Packed',
      },
    }
  },
  computed: {
    pending() {
      const data = this.orders.data
      const pendingData = data.filter((order) => order.status === 'Packed')
      return pendingData
    },
    processed() {
      const data = this.orders.data
      const processedData = data.filter((order) => order.status !== 'Packed')
      return processedData
    },
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(`/delivery-runs/${this.delivery_run.id}/invoicing-queue/orders`, pickBy(this.search), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.search = mapValues(this.search, () => null)
    },
  },
}
</script>
      